import React from "react";
import  "./spinner.scss";

const MiniSpinner = ({ label = "Loading..." }) => {
  return (
    <div className="mini-spinner-wrapper">
      <div className="mini-spinner" />
      <span className="mini-spinner-label">{label}</span>
    </div>
  );
};

export default MiniSpinner;
